import type { PostTablesLoadBalancingVirtualServersPathRules200DataItem } from '@ipfabric/api-client/client/schemas';
import type { NamedCellContentRenderFunction } from '@ipfabric/utils/table/columns/TableColumnConfig';
import { createRenderPlaintextModalCell } from 'components/Table/customRender/renderPlaintextModalCell';
import { renderRoutingMatchList } from 'components/Table/customRender/renderRoutingMatchList';
import type { TableCellContentRenderFunction } from 'components/Table/model/TableCellContentRenderFunction';

export const namedCellContentRenderFunctions: {
  [Key in NamedCellContentRenderFunction]: TableCellContentRenderFunction<any>;
} = {
  routingMatchList: renderRoutingMatchList,
  loadBalancingVirtualServersPathRulesConfiguration:
    createRenderPlaintextModalCell<PostTablesLoadBalancingVirtualServersPathRules200DataItem>(
      {
        cellButtonIcon: 'fa-file-code',
        cellButtonTitle: 'Rule definition',
        key: 'config',
        modalTitle: 'Rule definition',
        textAreaTitle: (
          row: PostTablesLoadBalancingVirtualServersPathRules200DataItem,
        ) => row.ruleName ?? '(no name)',
      },
    ),
};
